/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface AgreementWebhookRequestBodyWebhookUrlInfo
 */
export interface AgreementWebhookRequestBodyWebhookUrlInfo {
  /**
   * Webhook url info
   * @type string
   * @memberof AgreementWebhookRequestBodyWebhookUrlInfo
   */
  url?: string
}

export function AgreementWebhookRequestBodyWebhookUrlInfoFromJSON(
  json: any
): AgreementWebhookRequestBodyWebhookUrlInfo {
  return AgreementWebhookRequestBodyWebhookUrlInfoFromJSONTyped(json, false)
}

export function AgreementWebhookRequestBodyWebhookUrlInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AgreementWebhookRequestBodyWebhookUrlInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    url: !exists(json, 'url') ? undefined : json['url'],
  }
}

export function AgreementWebhookRequestBodyWebhookUrlInfoToJSON(
  value?: AgreementWebhookRequestBodyWebhookUrlInfo | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    url: value.url,
  }
}
